import {Fragment, React} from '@api';
import {usePdfStore} from '@modules/pdf'
import {StyleSheet, Text, View} from "@react-pdf/renderer";
import {useStores} from '@modules'

import { ProductPageHeader } from './vlp/VlpProductPage'

export const CoverPageOut : React.FunctionComponent<any> = () => {
  const styles = StyleSheet.create(_.merge({}, {
    page: {
      fontFamily: 'Helvetica',
    },

    corner:           {
      display:       'flex',
      flexDirection: 'row',
    },
    cornerText:       {
      fontFamily:    'Helvetica',
      alignSelf:     'center',
      textTransform: 'capitalize'
    },
    cornerText_large: {
      fontSize: 18
    },
    cornerText_small: {
      fontSize: 12
    },

    centerTitle: {
      display:       'flex',
      flexDirection: 'column',
      flex:          0,
      fontFamily:    'Arial',

      justifyItems: 'center',
      justifySelf:  'center',
      alignSelf:    'center',
      alignItems:   'center',

      marginTop:     'auto',
      marginBottom:  'auto'
    },

    title:    {
      fontSize: 40,
    },
    subtitle: {
      fontSize:      25,
      marginTop:     30,
      justifyItems:  'center',
      letterSpacing: 2
    },

    subject: {
      fontSize:      16,
      marginTop:     20,
      justifyItems:  'center',
      letterSpacing: 1
    },

    footer: {},

    company:         {
      fontSize:      18,
      letterSpacing: -0.5
    },
    companyLocation: {
      fontSize:      15,
      marginTop:     4,
      letterSpacing: 3
    }
  }) as any)

  const {
          site: {seasonal: {season, category1, category2}}
        } = useStores(),
    {renderPage, config, selectedPdfDocument: {size, subject, title, subtitle, orientation}} = usePdfStore()

        
  return renderPage({
    hideTitle: true,
    children: <Fragment>
               <ProductPageHeader />
                {/*<View style={styles.corner}>*/}
                {/*  <Text style={{...styles.cornerText, ...styles.cornerText_large}}>{_.upperCase(category2 ? category2.name : category1 ? category1.name : season ? season.name : subject)}&nbsp;</Text>*/}
                {/*  <Text style={{...styles.cornerText, ...styles.cornerText_small, paddingLeft: 4}}>{_.upperCase('Book')}</Text>*/}
                {/*</View>*/}

                <View style={styles.centerTitle}>
                  <Text style={styles.title}>{_.upperCase(title ? title : season ? season.name : 'My Report')}</Text>
                  <Text style={styles.subtitle}>{_.upperCase(subtitle ? subtitle : category1 ? category1.name : subtitle)}</Text>
                  {!_.isEmpty(subject) && <Text style={styles.subject}>{_.upperCase(subject)}</Text>}
                </View>
              </Fragment>
  }) as any
}

export const EmptyPdfPage : React.FunctionComponent<{text?: string}> = ({text}) => {
  const pdf = usePdfStore()

  return pdf.renderPage({
    children: <Fragment>
      <Text style={{margin: 'auto'}}>{text || `This page intentionally left blank`}</Text>
    </Fragment>
  }) as any
}


// WEBPACK FOOTER //
// ./src/modules/pdf/templates/cover-page.tsx